import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { allProductGroupsAtom } from 'shared/api/masters'
import React from 'react'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { objectFieldSort } from 'shared/utils'

export function SelectGroupDropdown({
  onSelect,
  selectedId,
}: {
  selectedId?: number
  onSelect: (id: number) => void
}) {
  const allGroups = useAtomValue(allProductGroupsAtom).sort(
    objectFieldSort('name'),
  )
  const onChange = ({ target: { value } }: SelectChangeEvent<number>) => {
    onSelect(Number(value))
  }
  return (
    <Select value={selectedId} onChange={onChange}>
      {allGroups.map((group) => {
        return (
          <MenuItem key={group.id} value={group.id}>
            {group.name}
          </MenuItem>
        )
      })}
    </Select>
  )
}
